/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {
 *         ifMatch: "If-Match",
 *         labels: {
 *             "key": "value"
 *         }
 *     }
 */
export interface PresentationUpdateLabelsRequest {
    /**
     * From [Zalando RESTful API Guidelines - models/headers-1.0.0.yaml](https://opensource.zalando.com/restful-api-guidelines/models/headers-1.0.0.yaml).
     * The **Idempotency-Key** is a free identifier created by the client to
     * identify a request. It is used by the service to identify repeated request
     * to ensure idempotent behavior by sending the same (or a similar) response
     * without executing the request a second time.
     *
     * Clients should be careful as any subsequent requests with the same key may
     * return the same response without further check. Thus, it is recommended to
     * use a UUID version 4 (random) or any other random string with enough
     * entropy to avoid collisions.
     *
     * Keys expire after 24 hours. Clients are responsible to stay within this
     * limit, if they require idempotent behavior.
     *
     * See [API Guideline Rule #181](https://opensource.zalando.com/restful-api-guidelines/#230) for further details.
     */
    idempotencyKey?: string;
    /**
     * From [Zalando RESTful API Guidelines - models/headers-1.0.0.yaml](https://opensource.zalando.com/restful-api-guidelines/models/headers-1.0.0.yaml).
     * The **If-Match** header field is used to declare a list of identifiers that
     * are required to match the current resource version identifier in at least
     * one position as a pre-condition for executing the request on the server
     * side. This behavior is used to validate and reject optimistic updates, by
     * checking if the resource version a consumer has based his changes on is
     * outdated on arrival of the change request to prevent lost updates.
     *
     * If the pre-condition fails the server will respond with status code **412**
     * (Precondition Failed). See [RFC 9110 Section 13.1.1][rfc-9110-13.1.1] as
     * well as [API Guideline Rule #182][api-182] for further details.
     *
     * [rfc-9110-13.1.1]: <https://tools.ietf.org/html/rfc9110#section-13.1.1>
     * [api-182]: <https://opensource.zalando.com/restful-api-guidelines/#182>.
     */
    ifMatch: string;
    /** The labels of the resource. */
    labels: Record<string, string>;
}
